export async function resizeImage(dataURL: string, maxWidth: number): Promise<string> {
  const loadImage = (file: string) =>
    new Promise<string>((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        let { width, height } = image;
        const size = maxWidth > 256 ? maxWidth : width;
        if (width > height) {
          if (width > size) height *= size / width;
          else height = (height / width) * size;
          width = size;
        } else {
          width *= size / height;
          height = size;
        }

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (!context) {
          reject(new Error('Error load Canvas.'));
          return;
        }

        canvas.width = width;
        canvas.height = height;
        context.drawImage(image, 0, 0, width, height);

        resolve(canvas.toDataURL('image/png', 0.9));
      };

      image.onerror = (err) => reject(err);
      image.src = file;
    });

  return loadImage(dataURL);
}
